// Оригинальный fetch, снятый до того, как httpInterceptor подменит window.fetch.
//
// Через него ходят запросы, которым экран обслуживания показывать не нужно:
// фоновые и некритичные. Такие вызовы уже завёрнуты в try/catch и молча
// переживают отказ ручки, но перехватчик срабатывал раньше catch — на сыром
// статусе ответа — и утаскивал на заглушку весь сайт. Один фоновый 503 клал
// главную и живым людям, и роботу (RBXGD-1119).
//
// Отдельный модуль без импортов, а не экспорт из httpInterceptor: тот тянет
// store, а store тянет это — вышел бы цикл. Порядок гарантирован тем, что
// модули вычисляются до тела main.js, а подмена происходит уже в нём.
export const rawFetch = window.fetch.bind(window)

export default rawFetch
